interface FormatterParams {
  key: string;
  argumentValue: string;
}

const TRUST_INDICATORS_LOWERCASED_KEYS = {
  napCheck: 'napcheck',
  apkUponDelivery: 'apkupondelivery',
  bovag: 'warrantybovag',
};

const TRUST_INDICATORS_LOGOS_BY_KEY = {
  [TRUST_INDICATORS_LOWERCASED_KEYS.napCheck]: 'logo-nap',
  [TRUST_INDICATORS_LOWERCASED_KEYS.bovag]: 'carwarranties-warranties-bovaghorizontal',
};

const getLookUpKey = ({ key, argumentValue }: FormatterParams) => {
  return key.toLowerCase() === 'warranty' ? `${key}${argumentValue}` : key;
};

const getTrustIndicatorValue = (
  { key, argumentValue }: FormatterParams,
  i18n: { t: (key: string, options?: any) => string },
): string => {
  const highlightKey = `listings.highlights.${key}`;
  if (key.toLowerCase() === 'warranty') {
    if (!argumentValue) {
      return i18n.t(highlightKey);
    }
    // TODO: Avoid searching for dutch text
    if (argumentValue.toLowerCase().includes('garantie')) {
      return i18n.t(argumentValue);
    }
    return i18n.t(`listings.highlights.DetailedWarranty`, { warrantyLabel: argumentValue });
  }
  return i18n.t(highlightKey, { argumentValue });
};

const getTrustIndicatorLogo = (trustIndicator: FormatterParams): string | undefined => {
  const logoKey = getLookUpKey(trustIndicator);

  return TRUST_INDICATORS_LOGOS_BY_KEY[logoKey.toLowerCase()];
};

const trustIndicatorsFormatter = (
  trustIndicators: FormatterParams[],
  i18n: { t: (key: string, options?: any) => string },
) => {
  return trustIndicators.map((ti) => ({
    ...ti,
    value: getTrustIndicatorValue(ti, i18n),
    logo: getTrustIndicatorLogo(ti),
  }));
};

export default trustIndicatorsFormatter;
